import {AxiosResponse} from 'axios';

export const getResourceId = (response: AxiosResponse): number => {
    const locationHeader: string = response.headers.location;
    const id: number = parseInt(locationHeader.substr(locationHeader.lastIndexOf('/') + 1));

    return id;
};
